module.exports = __webpack_public_path__ + "u17.no2.29d3b717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u17.no2.jpg
// module id = lNWC
// module chunks = 0